/**
 * The XOF has no subunit in daily use: amounts are whole numbers grouped by a
 * narrow no-break space, and the symbol reads "F" rather than the ISO code.
 */
const XOF = "XOF";

const wholeAmount = new Intl.NumberFormat("fr-FR", {
  maximumFractionDigits: 0,
});

const decimalAmount = new Intl.NumberFormat("fr-FR", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatAmount(amount: number, currency = XOF): string {
  return currency === XOF ? wholeAmount.format(amount) : decimalAmount.format(amount);
}

export function formatMoney(amount: number, currency = XOF): string {
  const symbol = currencySymbol(currency);
  return `${formatAmount(amount, currency)} ${symbol}`;
}

/** Accepts the French decimal comma and optional spacing in money fields. */
export function parseLocalizedNumber(value: string): number {
  return Number(value.trim().replace(/\s/g, "").replace(",", "."));
}

/** "F" only stands for the XOF; any other currency keeps its ISO code. */
export function currencySymbol(currency = XOF): string {
  return currency === XOF ? "F" : currency;
}

/** French agrees the plural from 2 upward: "1 lot", but "0 lot" and "2 lots". */
export function plural(count: number, singular: string, many = `${singular}s`): string {
  return Math.abs(count) >= 2 ? many : singular;
}

/** Quantities keep their decimals: measurement precision can be 0.5 Kg. */
export function formatQuantity(quantity: number, unit?: string | null): string {
  const value = new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 2 }).format(quantity);
  return unit ? `${value} ${unit}` : value;
}
